export const styles = theme => ({
    disabled: {
        opacity: '1!important',
    },
});
